export default function (error) {
  const { response = {} } = error
  const { data, status } = response

  if (!data) return error

  return { data, status }
}
